import { apiClientes } from '../config/api';
import { RegistrarBeneficiario } from '../interfaces/entities/RegistrarBeneficiario';

export const registerClient = async (data: RegistrarBeneficiario): Promise<any | null> => {
  try {
    const response = await apiClientes.post('/Login/RegistrarBeneficiario', data);

    return response.data;

  } catch (error: any) {
    const errorData = error?.response;

    return errorData;
  }
};